import { FieldProps, FormConfig, FormInputProps } from 'brief-form'
import { LicenseEdit, LicenseForm } from '~bank-licenses/types'

export interface ManageLicenseFormProps {
  config: FormConfig<LicenseForm>
  Field: <Input extends React.ComponentType<FormInputProps<any, any>>>(
    props: FieldProps<Input, LicenseForm>
  ) => JSX.Element
  isDirty: boolean
  isLeaveConfirmationNeeded: boolean
  data: LicenseEdit
}
